import { dialogTexts } from "@features/faqs/constants";
import { useOnboardingGate } from "@features/onboardings/hooks/useOnboardingGate";
import GlobalPodcastPlayer from "@features/podcasts/components/GlobalPodcastPlayer";
import AutoRedeemDialogContainer from "@features/redeem/components/AutoRedeemDialogContainer";
import QAChatWrapper from "@features/session/components/QASearch/QAChatWrapper";
import { useAppStore } from "@hooks/useAppStore";
import { isWeb } from "@memorang/helpers/platform";
import Box from "@memorang/ui/components/Box";
import ModalHeader from "@memorang/ui/components/ModalHeader";
import { useDevice } from "@memorang/ui/useDevice";
import { Redirect, Stack, usePathname, useRouter } from "expo-router";
import { t } from "i18next";

export default function Layout() {
	const router = useRouter();
	const pathname = usePathname();
	const { isIpad } = useDevice();
	const { needsOnboarding } = useOnboardingGate();

	const purchaseSchema = useAppStore((state) => state.app?.purchase);

	const modalVariant = isIpad
		? ("containedModal" as const)
		: ("modal" as const);

	// /onboarding is a screen of the Stack below, so the redirect renders
	// alongside it rather than replacing it — returning early here would unmount
	// the navigator that owns the route we are redirecting to. usePathname()
	// drops the query string, so onboarding's ?step= is not an issue.
	const redirectToOnboarding = needsOnboarding && pathname !== "/onboarding";

	return (
		<Box flex={1} flexDirection="row" justifyContent="space-between">
			{redirectToOnboarding && <Redirect href="/onboarding" />}
			<Stack
				screenOptions={{
					headerShown: false,
					contentStyle: {
						flex: 1,
					},
				}}
			>
				<Stack.Screen
					name="purchase/index"
					options={{
						presentation: modalVariant,
						headerShown: true,
						header: () => (
							<ModalHeader
								headerTitle={purchaseSchema?.paywall?.title || "Purchase"}
								onBack={() => router.back()}
							/>
						),
					}}
				/>
				<Stack.Screen
					name="session/customize"
					options={{
						presentation: modalVariant,
						headerShown: true,
						header: () => (
							<ModalHeader
								backIcon="arrow-left"
								headerTitle={t("sessionConfig.title")}
								onBack={() => router.back()}
							/>
						),
					}}
				/>
				<Stack.Screen
					name="suggestcorrection"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="faqs"
					options={{
						presentation: modalVariant,
						headerShown: true,
						header: () => (
							<ModalHeader
								backIcon="arrow-left"
								headerTitle={t(dialogTexts.faqs.title)}
								onBack={() => router.back()}
							/>
						),
					}}
				/>
				<Stack.Screen
					name="info"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="feedback"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="exams"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="aila/[itemId]"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
			</Stack>
			{isWeb && <QAChatWrapper />}
			<GlobalPodcastPlayer />
			<AutoRedeemDialogContainer />
		</Box>
	);
}
